/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditAcquirer(props) {
  const token = localStorage.getItem("token");
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const [acquirer, setAcquirer] = useState("");
  const [acquirerError, setAcquirerError] = useState(null);
  const [bankCode, setBankCode] = useState("");
  const [bankCodeError, setBankCodeError] = useState(null);

  const validateForm = () => {
    let error = false;
    if (acquirer === "") {
      setAcquirerError("invalid");
      error = true;
    }
    if (bankCode === "") {
      setBankCodeError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getAllAcquirerById();
  }, []);

  const getAllAcquirerById = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/acquirer/${props.match.params.id}`, {
      method: 'GET', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
        const responseData = data.response_data;
        setAcquirer(responseData.acquirer_name);
        setBankCode(responseData.acquirer_code);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function UpdateData() {
    setLoading(true);
    let body = {
      acquirer_name: acquirer,
      acquirer_code: bankCode
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/acquirer/update/${props.match.params.id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/acquirer");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      UpdateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Edit Acquirer" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Edit Acquirer</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="serial_number"
                      >
                        Acquirer
                                            </Label>
                      <Input
                        type="text"
                        name="acquirer_name"
                        placeholder="Masukan Acquirer Name"
                        value={acquirer}
                        invalid={acquirerError === "invalid"}
                        onChange={(e) => {
                          setAcquirer(e.target.value);
                          if (e.target.value !== "") {
                            setAcquirerError("");
                          }
                        }}
                      />
                      <FormFeedback>Acquirer tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Bank Code
                                            </Label>
                      <Input
                        type="text"
                        name="acquirer_code"
                        placeholder="Masukan Bank Code"
                        value={bankCode}
                        invalid={bankCodeError === "invalid"}
                        onChange={(e) => {
                          setBankCode(e.target.value);
                          if (e.target.value !== "") {
                            setBankCodeError("");
                          }
                        }}
                      />
                      <FormFeedback>Bank Code tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link class="btn btn-info" to="/admin/acquirer">
                      Cancel
                                        </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
